import React from 'react';
import _ from 'lodash';
import { Link } from 'gatsby';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import BoxedContainer from './layouts/BoxedContainer';

function FreeZoneTwoColImageCompose({ id, data }) {

  const title = _.get(data, 'title', '');
  const text = _.get(data, 'text', '');
  const cta = _.get(data, 'cta', {});
  const image1 = _.get(data, 'image1', {});
  const image2 = _.get(data, 'image2', {});

  return (
    <section id={id} className="relative">
      <BoxedContainer variant="xl">
        <div
          className="w-full grid grid-cols-6 lg:grid-cols-12 py-6 lg:py-10 gap-16 lg:gap-12.5
          lg:min-h-155">
          <div
            className="col-span-6 lg:col-span-5 flex flex-col items-center lg:items-start gap-5">
            <div
              className="child:text-clamp20to40 child:ltr:!font-URWDINMedium child:rtl:!font-GESSTwoDWTCMedium
              child:leading-[1.3] last:child:!m-0
              child:text-center lg:child:text-start"
              dangerouslySetInnerHTML={{ __html: title }}
            />
            <div className="py-px bg-red w-10 lg:w-12.5" />
            <div
              className="child:text-clamp12to18 child:ltr:!font-URWDINRegular child:rtl:!font-GESSTwoDWTCLight child:leading-1.4
              last:child:!m-0 child:text-center col-span-6 lg:child:text-start child:text-[#4D4D4D]"
              dangerouslySetInnerHTML={{ __html: text }}
            />
            {_.isEmpty(cta) || (
              <Link
                to={cta.url}
                className="text-clamp11to15 py-3 px-12 bg-red uppercase tracking-widest rounded-full
                col-span-4 text-center text-white col-start-2 lg:col-start-1 lg:col-span-3">
                {cta.name}
              </Link>
            )}
          </div>
          <div className="col-span-6 lg:col-span-7 relative grid grid-cols-6">
            {_.isEmpty(image1) || (
              <LazyLoadImage
                src={image1.url}
                alt="image composition"
                width={754}
                height={620}
                className="object-cover col-span-5 h-full"
              />
            )}
            {_.isEmpty(image2) || (
              <LazyLoadImage
                src={image2.url}
                alt="image composition"
                className="object-cover absolute top-1/2 right-0 -translate-y-1/2 aspect-49/58 h-3/5
                w-auto"
              />
            )}
          </div>
        </div>
      </BoxedContainer>
    </section>
  );
}

export default FreeZoneTwoColImageCompose;
